<template>
  <div class="page-container">
    <div class="page-header">
      <div class="d-flex align-items-center w-100">
        <b-link class="mr-3" @click="onBack()">
          <v-icon name="buttons/chevrons_left" :size="15"/>
        </b-link>
        <h4 class="mr-auto">Акт сверки</h4>
        <b-overlay
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="success"
          class="d-inline-block"
          @hidden="onHiddenExportButtonOverlay"
        >
          <b-button ref="export_file_button" class="custom-btn-secondary mr-1" @click.stop="exportFileGate('docx')">
            <v-icon name="buttons/export" :size="12"/>
            Экспорт в Docx
          </b-button>
        </b-overlay>
        <b-overlay
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="success"
          class="d-inline-block"
          @hidden="onHiddenExportPdfButtonOverlay"
        >
          <b-button ref="export_pdf_file_button" class="custom-btn-secondary mr-1" @click.stop="exportFileGate('pdf')">
            <v-icon name="buttons/export" :size="12"/>
            Экспорт в PDF
          </b-button>
        </b-overlay>
        <b-button class="custom-btn-primary" :disabled="loading" @click="handleSubmit()">
          <b-spinner v-if="loading" small/>
          <v-icon name="buttons/check" :size="13"/>
          Сохранить
        </b-button>
      </div>
    </div>

    <div class="page-body" style="overflow-y: auto;">
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-card no-body>
            <b-container fluid class="my-2">
              <b-card bg-variant="light">
                <b-row align-h="center" class="mt-2">
                  <b-col lg="4">
                    <b-skeleton width="47%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                  <b-col lg="4">
                    <b-skeleton width="43%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                </b-row>
                <b-row align-h="center" class="mb-2">
                  <b-col lg="3">
                    <b-skeleton width="43%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                  <b-col lg="3">
                    <b-skeleton width="40%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                </b-row>
                <b-row align-h="center">
                  <b-col cols="1">
                    <b-skeleton type="input" width="100%" height="80%"/>
                  </b-col>
                </b-row>
              </b-card>
            </b-container>
            <b-container fluid class="my-2">
              <b-card bg-variant="light" no-body class="p-1">
                <b-card no-body bg-variant="light">
                  <div class="text-center text-muted d-flex align-items-center justify-content-center">
                    <div class="spinner">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                    <h5>Загрузка таблицы</h5>
                  </div>
                </b-card>
              </b-card>
            </b-container>
          </b-card>
        </template>
      </b-skeleton-wrapper>

      <div v-show="!isBusy">

          <b-form @submit.stop.prevent="handleSubmit">

              <b-card class="custom-card mb-2">
                <b-row align-h="center">
                  <b-col lg="4">
                    <b-form-group
                      id="group_organization"
                      label="Организация (продавец)"
                      label-for="input_organization"
                    >
                      <organization-select
                        id="input-org-select"
                        ref="organization_select"
                        :value="newItem.organization_id"
                        :state="getFieldState('organization_id')"
                        @onSelect="onSelectOrg"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group
                      id="group_customer"
                      label="Заказчик (покупатель)"
                      label-for="input_customer"
                    >
                      <customer-select
                        id="input-customer-select"
                        ref="customer_select"
                        :state="getFieldState('customer_id')"
                        :value="newItem.customer_id"
                        @onSelect="onSelectCustomer"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row align-h="center">
                  <b-col lg="3">
                    <b-form-group
                      id="group-start-period"
                      label="Начало периода"
                      label-for="input-start-period"
                    >
                      <b-form-input
                        id="input-start-period"
                        size="sm"
                        type="date"
                        v-model.date="startPeriod"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group
                      id="group-end-period"
                      label="Конец периода"
                      label-for="input-end-period"
                    >
                      <b-form-input
                        id="input-end-period"
                        size="sm"
                        type="date"
                        v-model.date="endPeriod"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="d-flex justify-content-center">
                  <b-button class="custom-btn-secondary" @click="getDetails()">
                    <v-icon name="buttons/fill" :size="13"/>
                    Заполнить
                  </b-button>
                </div>
              </b-card>

          </b-form>

          <div class="page-table-container">

              <b-table
                id="act-details"
                ref="act_details"
                class="custom-table mb-0 text-small"
                sticky-header
                selectable
                select-mode="single"
                responsive
                show-empty
                :empty-text="$t('message.common.emptyTable')"
                :busy="isBusy"
                :items="details.items"
                :fields="detailsFields"
                no-provider-filtering
                no-provider-paging
                no-provider-sorting
              >
                <template #table-busy>
                  <div class="text-center text-success my-2">
                    <b-spinner class="align-middle"/>
                    <strong>Загрузка</strong>
                  </div>
                </template>

                <template #thead-top="data">
                  <b-tr>
                    <b-th colspan="3" class="text-right">Сальдо начальное</b-th>
                    <b-th>
                      <b-form-input
                        id="input-start-saldo-debit"
                        class="act-details-debit"
                        size="sm"
                        v-model.number="newItem.start_debit"/>
                    </b-th>
                    <b-th>
                      <b-form-input
                        id="input-start-saldo"
                        class="act-details-credit"
                        size="sm"
                        v-model.number="newItem.start_credit"/>
                    </b-th>
                  </b-tr>
                </template>

                <template #custom-foot="data">
                  <b-tr>
                    <b-th colspan="3" class="text-right">Обороты</b-th>
                    <b-th>
                      <div class="act-details-debit">
                        {{priceFormat(totalDebit)}}
                      </div>
                    </b-th>
                    <b-th>
                      <div class="act-details-credit">
                        {{priceFormat(totalCredit)}}
                      </div>
                    </b-th>
                  </b-tr>
                  <b-tr>
                    <b-th colspan="3" class="text-right">Конечное сальдо</b-th>
                    <b-th>
                      <div class="act-details-debit">
                        {{priceFormat(endSaldoDebit)}}
                      </div>
                    </b-th>
                    <b-th>
                      <div class="act-details-credit">
                        {{priceFormat(endSaldoCredit)}}
                      </div>
                    </b-th>
                  </b-tr>
                </template>

                <template #cell(invoice_numb)="row">
                  <b-button style="padding: 0px" size="sm" variant="link" @click.stop="onInvoice(row.item)">
                    {{row.item.invoice_numb}}
                  </b-button>
                </template>

                <template #cell(entity_date)="row">
                  {{formatTableDate(row.item.entity_date)}}
                </template>

                <template #cell(name)="row">
                  {{getName(row.item)}}
                </template>

                <template #cell(debit)="row">
                  {{priceFormat(row.item.debit)}}
                </template>

                <template #cell(credit)="row">
                  {{priceFormat(row.item.credit)}}
                </template>

                <template #cell(active)="row">
                  <font-awesome-icon v-if="!row.item.active" icon="times"/>
                  <font-awesome-icon v-if="row.item.active" icon="check"/>
                </template>
              </b-table>

          </div>


        <export-file ref="exportFile"/>
      </div>
    </div>
  </div>
</template>

<script>
import reconciliationActs from "../../network/reconciliationActs";
import organizations from "../../network/organizations";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import CustomerSelect from "../Customers/CustomerSelect";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import {parse} from "content-disposition-attachment";
    import ExportFile from "../Invoices/ExportFile";

export default {
  name: "ReconciliationAct",
  components: { OrganizationSelect, CustomerSelect, ExportFile },
  mixins: [
    reconciliationActs, organizations,
    helpers, dateFormatter
  ],
  data() {
    return {
      newItem: {
        id: 0,
        start_period: '',
        end_period: '',
        customer_id: 0,
        customer_name: '',
        organization_id: 0,
        organization_name: '',
        start_debit: 0,
        start_credit: 0,
        end_debit: 0,
        end_credit: 0,
        active: true
      },
      startPeriod: this.formatDate(new Date()),
      endPeriod: this.formatDate(new Date()),
      isBusy: false,
      details: {
        items: [],
        total_count: 0,
        total_debit: 0,
        total_credit: 0,
      },
      detailsFields: [
        {
          key: 'invoice_numb',
          label: "Номер счёта",
          class: 'act-details-numb'
        },
        {
          key: 'entity_date',
          label: "Дата",
          class: 'act-details-date'
        },
        {
          key: 'name',
          label: "Наименование документа",
          class: ''
        },
        {
          key: 'debit',
          label: "Дебет",
          class: 'act-details-debit'
        },
        {
          key: 'credit',
          label: "Кредит",
          class: 'act-details-credit'
        },
      ],
      loading: false
    }
  },
  async created() {
    await this.updateView();
  },
  methods: {
    async updateView() {
      const id = this.$route.params.id;
      if (id) {
        await this.getReconciliationAct(id);
      }
    },
    async getReconciliationAct(id) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getReconciliationActById(id);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      const startP = this.getDateFromServerString(this.newItem.start_period);
      this.startPeriod = this.formatDate(startP);
      const endP = this.getDateFromServerString(this.newItem.end_period);
      this.endPeriod = this.formatDate(endP);

      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.newItem.organization_id);
      }

      if (this.$refs.customer_select != null) {
        await this.$refs.customer_select.configure(this.newItem.customer_id);
      }

      await this.getDetails();
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const path = '/reconciliation_acts';
        this.$router.push(path).catch(()=>{});
      }
    },
    async handleSubmit() {
      if (this.newItem.organization_id === 0) {
        this.showSubmitError("Выберите организацию.");
        return;
      }

      if (this.newItem.customer_id === 0) {
        this.showSubmitError("Выберите заказчика.");
        return;
      }

      if (!this.isDateValid(this.startPeriod)) {
        this.showSubmitError("Выберите дату начала периода.");
        return;
      }

      if (!this.isDateValid(this.endPeriod)) {
        this.showSubmitError("Выберите дату конца периода.");
        return;
      }

      this.newItem.start_period = this.getDateToServer(this.startPeriod).toISOString();
      this.newItem.end_period = this.getDateToServer(this.endPeriod).toISOString();

      this.newItem.end_debit = this.endSaldoDebit;
      this.newItem.end_credit = this.endSaldoCredit;

      this.loading = true;
      const data = { ...this.newItem };

      const method = (data.id > 0) ? this.putReconciliationAct : this.postReconciliationAct;
      const result = await method(data);

      if (result.status === 422) {
        this.showSubmitError("Проверьте правильность заполнения полей.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.onBack();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    async getDetails() {
      const data = {
        start_date: this.startPeriod,
        end_date: this.endPeriod,
        organization_id: this.newItem.organization_id,
        customer_id: this.newItem.customer_id,
      }

      this.isBusy = true;
      this.loading = true;

      const result = await this.getReconciliationActDetails(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.details = result.data;
      this.isBusy = false;
      this.loading = false;
    },
    async onSelectOrg(orgId) {
      this.newItem.organization_id = orgId;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    async onSelectCustomer(customerId) {
      this.newItem.customer_id = customerId;
      if (this.$refs.customer_select != null) {
        this.newItem.customer_name = this.$refs.customer_select.item.name;
      }
    },
    getName(item) {
      const date = this.formatTableDate(item.entity_date);
      const numb = item.entity_numb;

      if (item.type_id === 1) {
        return `Продажа (Акт ${numb} от ${date})`;
      }

      if (item.type_id === 2) {
        return `Оплата (Счёт ${numb} от ${date})`;
      }
      return ""
    },
    onInvoice(item) {
      const routeData = this.$router.resolve({name: 'InvoiceEdit', params: { invoice_id: item.invoice_id }});
      window.open(routeData.href, '_blank');
    },
    calculateSaldo() {
      return (this.newItem.start_debit - this.newItem.start_credit) + this.totalDebit - this.totalCredit;
    },
    async exportFileGate(exportType) {
      const stampRes = await this.getStamps(this.newItem.organization_id);
      const ifHasStamp = stampRes.data.stamp || stampRes.data.director_sign;

      if (ifHasStamp !== "") {
        this.$refs.exportFile.show(function (hasStamp) {
          this.exportFile(this.newItem.id, exportType, hasStamp);
        }.bind(this));
      } else {
        await this.exportFile(this.newItem.id, exportType, false);
      }
    },
    onHiddenExportButtonOverlay() {
      this.$refs.export_file_button.focus();
    },
    onHiddenExportPdfButtonOverlay() {
      this.$refs.export_pdf_file_button.focus();
    },
    getFileName(disposition) {
      const defaultName = "untitled";

      if (!disposition) return defaultName;

      try {
        const { attachment, filename } = parse(disposition);
        return attachment ? filename : defaultName;
      } catch (e) {
        console.error(e);
        return defaultName;
      }
    },
    async exportFile(id, exportType, hasStamp) {
      const data = { id, exportType, hasStamp }

      this.loading = true;
      const result = await this.getReconciliationActFile(data);

      if (result.error || !result.data) {
        this.showGenerateFileError("Ошибка создания файла", "Не удалось выполнить создание DOCX файла. Попробуйте повторить позднее.");
        this.loading = false;
        return;
      }

      const fileName = this.getFileName(result.headers.get('content-disposition')).replace(/[+]/g,' ');

      this.handleFileDownload(result.data, fileName);
      this.loading = false;
    },
  },
  computed: {
    totalDebit() {
      return this.details.items
          .map(obj => obj.debit)
          .reduce((acc, current) => acc + current, 0);

    },
    totalCredit() {
      return this.details.items
          .map(obj => obj.credit)
          .reduce((acc, current) => acc + current, 0)
    },
    endSaldoDebit() {
      const result = this.calculateSaldo();
      if (result > 0) {
        return result;
      }
      return 0;
    },
    endSaldoCredit() {
      const result = this.calculateSaldo();
      if (result < 0) {
        return -result;
      }
      return 0;
    }
  },
}
</script>

<style>
#act-details td {
  vertical-align: middle;
}

#act-details th {
  vertical-align: middle;
}

.act-details-numb {
  width: 100px;
  text-align: center;
}

.act-details-date {
  width: 100px;
  text-align: center;
}

.act-details-debit {
  width: 200px;
}

.act-details-credit {
  width: 200px;
}

#modal-export-file .mb-3 {
  margin-bottom: 0 !important;
}

/* Skeleton table spinner */
.spinner {
  margin: 1%;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #e0e0e0;
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: sk-stretchdelay 1.4s infinite ease-in-out;
  animation: sk-stretchdelay 1.4s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
       transform: scaleY(1.0);
       -webkit-transform: scaleY(1.0);
     }
}
</style>



// WEBPACK FOOTER //
// src/components/ReconciliationActs/ReconciliationAct.vue